<template>
  <div>
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntIcone='false' :cpntTamanho='5'></RF-Status>
    
    <!-- MOSTRA A PAGINA -->
    <div v-else class="fin-con-ban-conciliar">
      <div class="filtros" v-show="cpntId === ''">
        <App-Select :data-time="time" class="fin-con-ban-conciliar--conta"
          :cpntStatus='campos.conta.status'
          :cpntId='campos.conta.id'
          :class='campos.conta.class'
          :cpntTabIndex='campos.conta.tabIndex'
          :cpntNome='campos.conta.nome'
          :cpntValue='campos.conta.value'
          :cpntMensagem='campos.conta.mensagem'
          :cpntMensagemTipo='campos.conta.mensagemTipo'
          :cpntDisabled='campos.conta.disabled'
          :cpntMostrar='campos.conta.mostrar'
          :cpntExplica='campos.conta.explica'
          :cpntPlaceholder='campos.conta.placeholder'
          :cpntValueRef='campos.conta.valueRef'
          :cpntRouter='campos.conta.router'
          :cpntMethod='campos.conta.method'
          :cpntField='campos.conta.field'
          :cpntWhere='campos.conta.where'
          :cpntAddButForm='campos.conta.addButForm'
          :cpntKeyMostra='campos.conta.keyMostra'
          :cpntTipoOrder='campos.conta.tipoOrder'
          :cpntOrder='campos.conta.order'
          :cpntOptions='campos.conta.options'
          :cpntKeyValue='campos.conta.keyValue'
          :cpntSearchMinimo='campos.conta.searchMinimo'
          :cpntMask='campos.conta.mask'
          :cpntOptionInicialNome='campos.conta.optionInicialNome'
          :cpntOptionInicialValue='campos.conta.optionInicialValue'
          :cpntNewOption='campos.conta.newOption'
          
          :cpntOnBuscarOptions='campos.conta.onBuscarOptions'
          :cpntOnChange='campos.conta.onChange'
          :cpntOnBlur='campos.conta.onBlur'
          :cpntOnRealizaBusca='campos.conta.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.conta.onKeyPressEnter'
          ref="conta"
        ></App-Select>

        <App-Seletor-Data :data-time="time" class="fin-con-ban-conciliar--periodo"
          :cpntStatus='campos.periodo.status'
          :cpntId='campos.periodo.id'
          :cpntTabIndex='campos.periodo.tabIndex'
          :cpntOptionInicialNome='campos.periodo.optionInicialNome'
          :cpntNome='campos.periodo.nome'
          :cpntValue='campos.periodo.value'
          :cpntDisabled='campos.periodo.disabled === true || finConBanConciliarValorConta() === ""'
          :cpntPosicao="'lado'"

          :cpntOnChange='campos.periodo.onChange'
          ref="periodo"
        ></App-Seletor-Data>

        <App-Select :data-time="time" class="fin-con-ban-conciliar--tpBusca"
          :cpntStatus='campos.tpBusca.status'
          :cpntId='campos.tpBusca.id'
          :class='campos.tpBusca.class'
          :cpntTabIndex='campos.tpBusca.tabIndex'
          :cpntNome='campos.tpBusca.nome'
          :cpntValue='campos.tpBusca.value'
          :cpntMensagem='campos.tpBusca.mensagem'
          :cpntMensagemTipo='campos.tpBusca.mensagemTipo'
          :cpntDisabled='campos.tpBusca.disabled === true || finConBanConciliarValorConta() === ""'
          :cpntMostrar='campos.tpBusca.mostrar'
          :cpntExplica='campos.tpBusca.explica'
          :cpntPlaceholder='campos.tpBusca.placeholder'
          :cpntValueRef='campos.tpBusca.valueRef'
          :cpntRouter='campos.tpBusca.router'
          :cpntMethod='campos.tpBusca.method'
          :cpntField='campos.tpBusca.field'
          :cpntWhere='campos.tpBusca.where'
          :cpntAddButForm='campos.tpBusca.addButForm'
          :cpntKeyMostra='campos.tpBusca.keyMostra'
          :cpntTipoOrder='campos.tpBusca.tipoOrder'
          :cpntOrder='campos.tpBusca.order'
          :cpntOptions='campos.tpBusca.options'
          :cpntKeyValue='campos.tpBusca.keyValue'
          :cpntSearchMinimo='campos.tpBusca.searchMinimo'
          :cpntMask='campos.tpBusca.mask'
          :cpntOptionInicialNome='campos.tpBusca.optionInicialNome'
          :cpntOptionInicialValue='campos.tpBusca.optionInicialValue'
          :cpntNewOption='campos.tpBusca.newOption'
          
          :cpntOnBuscarOptions='campos.tpBusca.onBuscarOptions'
          :cpntOnChange='campos.tpBusca.onChange'
          :cpntOnBlur='campos.tpBusca.onBlur'
          :cpntOnRealizaBusca='campos.tpBusca.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.tpBusca.onKeyPressEnter'
          ref="tpBusca"
        ></App-Select>

        <App-Select :data-time="time" class="fin-con-ban-conciliar--conciliado"
          :cpntStatus='campos.conciliado.status'
          :cpntId='campos.conciliado.id'
          :class='campos.conciliado.class'
          :cpntTabIndex='campos.conciliado.tabIndex'
          :cpntNome='campos.conciliado.nome'
          :cpntValue='campos.conciliado.value'
          :cpntMensagem='campos.conciliado.mensagem'
          :cpntMensagemTipo='campos.conciliado.mensagemTipo'
          :cpntDisabled='campos.conciliado.disabled === true || finConBanConciliarValorConta() === ""'
          :cpntMostrar='campos.conciliado.mostrar'
          :cpntExplica='campos.conciliado.explica'
          :cpntPlaceholder='campos.conciliado.placeholder'
          :cpntValueRef='campos.conciliado.valueRef'
          :cpntRouter='campos.conciliado.router'
          :cpntMethod='campos.conciliado.method'
          :cpntField='campos.conciliado.field'
          :cpntWhere='campos.conciliado.where'
          :cpntAddButForm='campos.conciliado.addButForm'
          :cpntKeyMostra='campos.conciliado.keyMostra'
          :cpntTipoOrder='campos.conciliado.tipoOrder'
          :cpntOrder='campos.conciliado.order'
          :cpntOptions='campos.conciliado.options'
          :cpntKeyValue='campos.conciliado.keyValue'
          :cpntSearchMinimo='campos.conciliado.searchMinimo'
          :cpntMask='campos.conciliado.mask'
          :cpntOptionInicialNome='campos.conciliado.optionInicialNome'
          :cpntOptionInicialValue='campos.conciliado.optionInicialValue'
          :cpntNewOption='campos.conciliado.newOption'
          
          :cpntOnBuscarOptions='campos.conciliado.onBuscarOptions'
          :cpntOnChange='campos.conciliado.onChange'
          :cpntOnBlur='campos.conciliado.onBlur'
          :cpntOnRealizaBusca='campos.conciliado.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.conciliado.onKeyPressEnter'
          ref="conciliado"
        ></App-Select>

        <div :data-time="time" class="fin-con-ban-conciliar--botao">
          <App-Button :cpntClass="'btn btn-primary'" :cpntIcone="'lupa'" @onClick="finConBanConciliarIniciar" :cpntDisabled='finConBanConciliarRealizarPesquisa() === false'></App-Button>
        </div>
      </div>

      <div class="buscar" style="border-top: none; border-radius: 0px;" v-if="cpntId === '' && finConBanConciliarValorConciliado() !== 'sim'">
        <div>
          <App-Toggles :data-time="time" class="fin-con-ban-conciliar--valor"
            :cpntStatus='campos.valor.status'
            :cpntId='campos.valor.id'
            :cpntClassDivField='campos.valor.classDivField'
            :cpntNome='campos.valor.nome'
            :cpntValue='campos.valor.value'
            :cpntMostrar='campos.valor.mostrar'
            :cpntMensagem='campos.valor.mensagem'
            :cpntMensagemTipo='campos.valor.mensagemTipo'
            :cpntOn='campos.valor.on'
            :cpntOff='campos.valor.off'
            :cpntExplica='campos.valor.explica'
            :cpntWidth='campos.valor.width'
            :cpntTabIndex='campos.valor.tabIndex'
            :cpntDisabled='campos.valor.disabled === true || finConBanConciliarRealizarPesquisa() === false'
            :cpntOnChange='campos.valor.onChange'
            :cpntOnBlur='campos.valor.onBlur'
            ref='valor'
          ></App-Toggles>

          <App-Toggles :data-time="time" class="fin-con-ban-conciliar--data"
            :cpntStatus='campos.data.status'
            :cpntId='campos.data.id'
            :cpntClassDivField='campos.data.classDivField'
            :cpntNome='campos.data.nome'
            :cpntValue='campos.data.value'
            :cpntMostrar='campos.data.mostrar'
            :cpntMensagem='campos.data.mensagem'
            :cpntMensagemTipo='campos.data.mensagemTipo'
            :cpntOn='campos.data.on'
            :cpntOff='campos.data.off'
            :cpntExplica='campos.data.explica'
            :cpntWidth='campos.data.width'
            :cpntTabIndex='campos.data.tabIndex'
            :cpntDisabled='campos.data.disabled === true || finConBanConciliarRealizarPesquisa() === false'
            :cpntOnChange='campos.data.onChange'
            :cpntOnBlur='campos.data.onBlur'
            ref='data'
          ></App-Toggles>
        </div>
      </div>

      <div class="conciliar" :data-time="time">
        <table class="titulo">
          <tr>
            <td>
              <!-- SETA O TITULO DO CAMPO -->
              <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> Rotina Fácil

              <!-- MOSTRA A SOMA DOS VALORES SELECIONADOS -->
              <span class="valor" :style="(Object.keys(selecionado.fin).length >= 1 ? '' : 'visibility: hidden;') + (finConBanConciliarSomaSelecionado('fin') === finConBanConciliarSomaSelecionado('ofx') ? 'color: green;' : '')">({{ finConBanConciliarSomaSelecionado('fin') }})</span>
            </td>
            <td style="height: 33px;">
              <div v-if="finConBanConciliarValorConciliado() !== 'sim' && (Object.keys(selecionado.fin).length >= 1 && Object.keys(selecionado.ofx).length >= 1) ? 'visibility: hidden;' : ''">
                <App-Button style="margin-bottom: 3px" 
                :cpntClass="(finConBanConciliarSomaSelecionado('fin') === finConBanConciliarSomaSelecionado('ofx') ? 'btn btn-primary btn-sm' : 'btn btn-warning btn-sm')"
                @onClick="finConBanConciliarRegistros"
                >Conciliar Registros</App-Button>

              </div>

              <div v-if="finConBanConciliarValorConciliado() === 'sim' && ((finConBanConciliarValorTipoBusca() === 'ofx' && Object.keys(selecionado.ofx).length === 1 && Object.keys(selecionado.fin).length >= 1) || (finConBanConciliarValorTipoBusca() === 'fin' && Object.keys(selecionado.fin).length === 1 && Object.keys(selecionado.ofx).length >= 1))">
                <App-Button style="margin-bottom: 3px"
                :cpntClass="'btn btn-danger btn-sm'"
                @onClick="finConBanExcluirConciliacao"
                >Excluir Conciliação</App-Button>
              </div>
            </td>
            <td>
              <!-- MOSTRA A SOMA DOS VALORES SELECIONADOS -->
              <span class="valor" :style="(Object.keys(selecionado.ofx).length >= 1 ? '' : 'visibility: hidden;') + (finConBanConciliarSomaSelecionado('fin') === finConBanConciliarSomaSelecionado('ofx') ? 'color: green;' : '')">({{ finConBanConciliarSomaSelecionado('ofx') }})</span>

              <!-- SETA O TITULO DO CAMPO -->
              Arquivo OFX <svg aria-hidden="true" class="fa fa-angle-double-left"></svg>
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td class="fin">
              <div :class="countAll.fin === null ? 'disabled' : ''">
                <template v-if="countAll.fin !== null">
                  <!-- SETA O STATUS DA PAGINA -->
                  <RF-Status v-if="statusFin !== ''" :cpntStatus='statusFin' :cpntIcone='false' :cpntTamanho='5'></RF-Status>

                  <!-- VERIFICA SE TEM QUE BLOQUEAR A BERTURA DA TELA -->
                  <template v-else-if="finConBanConciliarValorConciliado() === 'sim' && finConBanConciliarValorTipoBusca() === 'ofx' && Object.keys(selecionado.ofx).length >= 2">
                    <div style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
                      <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>
                      Atenção
                      <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>
                      <br/>
                      <br/>
                      Não é possivel buscar os registros conciliados para mais de um registro do ofx.
                      <br/>
                      <br/>
                      Por favor, busque apenas um registro por vez.
                    </div>
                  </template>

                  <!-- SETA O CONTEUDO DA TELA -->
                  <template v-else>
                    <div>
                      <App-Button v-if="finConBanConciliarValorConciliado() !== 'sim' && finConBanConciliarValorTipoBusca() === 'ofx'"
                      :cpntClass="'btn btn-sm btn-primary'"
                      @onClick="finConBanConciliarRegistarFinanceiro"
                      >Adicionar novo registro</App-Button>

                      <App-Button style="float: right;" v-if="linhas.fin.length >= 1"
                      :cpntClass="'btn btn-sm btn-default'"
                      @onClick="finConBanConciliarMarcarTodos('fin')">
                      <template v-if="linhas.fin.length !== Object.keys(selecionado.fin).length">
                        Marcar todos
                      </template>
                      <template v-else>
                        Desmarcar todos
                      </template>
                      </App-Button>
                    </div>
                    
                    <table class="fin-con-ban-con--registros">
                      <!-- <caption>
                        &nbsp;
                      </caption> -->
                      <tr>
                        <td>
                          <span>Cód.</span>
                        </td>
                        <td>
                          <span>Tipo</span>
                        </td>
                        <td>
                          <span>Valor</span>
                        </td>
                        <td>
                          <span>Vencimento</span>
                        </td>
                        <td>
                          <span>Descrição</span>
                        </td>
                      </tr>

                      <tr v-if="linhas.fin.length  === 0">
                        <td colspan="5" class="noselect" style="cursor: no-drop;">
                          Nenhum registro encontrado
                        </td>
                      </tr>

                      <tr v-else v-for="(linha, indexL) in linhas.fin" :key="'fin--' + indexL" :data-time="time" :class="finConBanConciliarLinhaMarcada(linha, 'fin')" @click="finConBanConciliarMarcarLinha(linha, 'fin')">
                        <td>
                          <span v-html="linha.id"></span>
                        </td>
                        <td>
                          <span v-html="linha._fin_tp"></span>
                        </td>
                        <td>
                          <span v-html="linha._valor"></span>
                        </td>
                        <td>
                          <span v-html="linha._vcto"></span>
                        </td>
                        <td>
                          <template v-if="linha.id_modulo === '10'">
                            <App-Button
                              :cpntTexto='finConBanConciliarBotaoMontarTexto(linha.id_mod_reg, "venda")'
                              :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                              @onClick='(cpntId) => { finConBanConciliarBotaoOnClick(linha.id_mod_reg, "venda") }'
                            ></App-Button>
                          </template>
                          <template v-else-if="linha.id_modulo === '51'">
                            <App-Button
                              :cpntTexto='finConBanConciliarBotaoMontarTexto(linha.id_mod_reg, "comissao")'
                              :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                              @onClick='(cpntId) => { finConBanConciliarBotaoOnClick(linha.id_mod_reg, "comissao") }'
                            ></App-Button>
                          </template>
                          <template v-else-if="linha.id_modulo === '11'">
                            <App-Button
                              :cpntTexto='finConBanConciliarBotaoMontarTexto(linha.id_mod_reg, "compra")'
                              :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                              @onClick='(cpntId) => { finConBanConciliarBotaoOnClick(linha.id_mod_reg, "compra") }'
                            ></App-Button>
                          </template>
                          <template v-else-if="linha.id_modulo === '40'">
                            <App-Button
                              :cpntTexto='finConBanConciliarBotaoMontarTexto(linha.id_mod_reg, "despesa")'
                              :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                              @onClick='(cpntId) => { finConBanConciliarBotaoOnClick(linha.id_mod_reg, "despesa") }'
                            ></App-Button>
                          </template>
                          <template v-else>
                            <span v-html="linha.id_mod_reg"></span>
                          </template>
                        </td>
                      </tr>

                      <tr v-if="countAll.fin > linhas.fin.length">
                        <td class="botao-mais noselect" colspan="5">
                          <a @click="() => { finConBanConciliarBuscarFinanceiro() }">Carregar mais</a>
                        </td>
                      </tr>
                    </table>
                  </template>
                </template>
              </div>
            </td>
            <td class="separador">
              &nbsp;
            </td>
            <td class="ofx">
              <div :class="countAll.ofx === null ? 'disabled' : ''">
                <template v-if="countAll.ofx !== null">
                  <!-- SETA O STATUS DA PAGINA -->
                  <RF-Status v-if="statusOfx !== ''" :cpntStatus='statusOfx' :cpntIcone='false' :cpntTamanho='5'></RF-Status>

                  <!-- VERIFICA SE TEM QUE BLOQUEAR A BERTURA DA TELA -->
                  <template v-else-if="finConBanConciliarValorConciliado() === 'sim' && Object.keys(selecionado.fin).length >= 2">
                    <div style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
                      <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>
                      Atenção
                      <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>
                      <br/>
                      <br/>
                      Não é possivel buscar os registros conciliados para mais de um registro financeiro.
                      <br/>
                      <br/>
                      Por favor, busque apenas um registro por vez.
                    </div>
                  </template>

                  <!-- SETA O CONTEUDO DA TELA -->
                  <template v-else>
                    <div>
                      <App-Button style="float: right;" v-if="linhas.ofx.length >= 1"
                      :cpntClass="'btn btn-sm btn-default'"
                      @onClick="finConBanConciliarMarcarTodos('ofx')">
                      <template v-if="linhas.ofx.length !== Object.keys(selecionado.ofx).length">
                        Marcar todos
                      </template>
                      <template v-else>
                        Desmarcar todos
                      </template>
                      </App-Button>
                    </div>

                    <table class="fin-con-ban-con--registros">
                      <tr>
                        <td>
                          <span>Cód.</span>
                        </td>
                        <td>
                          <span>Tipo</span>
                        </td>
                        <td>
                          <span>Valor</span>
                        </td>
                        <td>
                          <span>Vencimento</span>
                        </td>
                        <td>
                          <span>Descrição</span>
                        </td>
                      </tr>

                      <tr v-if="linhas.ofx.length  === 0">
                        <td colspan="5" class="noselect" style="cursor: no-drop;">
                          Nenhum registro encontrado
                        </td>
                      </tr>

                      <tr v-else v-for="(linha, indexL) in linhas.ofx" :key="'ofx--' + indexL" :data-time="time" :class="finConBanConciliarLinhaMarcada(linha, 'ofx')" @click="finConBanConciliarMarcarLinha(linha, 'ofx')">
                        <td>
                          <span v-html="linha.id"></span>
                        </td>
                        <td>
                          <span v-html="linha._fin_tp"></span>
                        </td>
                        <td>
                          <span v-html="linha._valor"></span>
                        </td>
                        <td>
                          <span v-html="linha._vcto"></span>
                        </td>
                        <td>
                          <span v-html="linha.memo"></span>
                        </td>
                      </tr>

                      <tr v-if="countAll.ofx > linhas.ofx.length">
                        <td class="botao-mais noselect" colspan="5">
                          <a @click="() => { finConBanConciliarBuscarConciliar() }">Carregar mais</a>
                        </td>
                      </tr>
                    </table>
                  </template>
                </template>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <App-Financeiro-Registrar-Varios v-if="adicionar.length >= 1"
    :cpntIds="adicionar"
    :cpntBancoId="finConBanConciliarValorConta()"
    :cpntFecharFormulario="finConBanConciliarFecharRegistarFinanceiro"
    ></App-Financeiro-Registrar-Varios>
    <!-- :cpntBancoId="finConBanConciliarValorTipoBusca()" -->
  </div>
</template>

<style scoped>
.fin-con-ban-conciliar {
  margin-top: 20px;
} 
  .fin-con-ban-conciliar > .filtros,
  .fin-con-ban-conciliar > .buscar {
    width: 750px;
    margin: 0px auto;
    background: #e9e9e9;
    border: 1px solid #ccc;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    padding: 22px 10px 10px 10px;
    border-bottom: 0px;
  }
    .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--conta,
    .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--conciliado,
    .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--periodo,
    .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--tpBusca {
      width: calc((100% / 4) - (80px / 4));
      min-width: calc((100% / 4) - (80px / 4));
      max-width: calc((100% / 4) - (80px / 4));
      display: inline-block;
    }
    .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--conta,
    .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--periodo,
    .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--tpBusca {
      margin-right: 10px;
    }
    .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--botao {
      width: 40px;
      display: inline-block;
      margin-top: 1px;
      vertical-align: top;
      margin-left: 10px;
    }
      .fin-con-ban-conciliar > .filtros > .fin-con-ban-conciliar--botao > button {
        width: 40px;
        height: 30px;
        padding: 0px;
      }
  
    .fin-con-ban-conciliar > .buscar > div > .fin-con-ban-conciliar--valor,
    .fin-con-ban-conciliar > .buscar > div > .fin-con-ban-conciliar--data {
      width: 200px;
    }
  .fin-con-ban-conciliar > .buscar > div {
    width: 410px;
    margin: 0px auto;
  }

  .fin-con-ban-conciliar > .buscar {
    margin-top: -12px;
  }

  .fin-con-ban-conciliar > .conciliar {
    background: #e9e9e9;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 15px;
  }
    .fin-con-ban-conciliar > .conciliar > table.titulo {
      width: 100%;
    }
      .fin-con-ban-conciliar > .conciliar > table.titulo > tr > td {
        text-align: center;
        width: 40%;
      }
      .fin-con-ban-conciliar > .conciliar > table.titulo > tr > td:last-child {
        padding-right: 4px;
        text-align: right;
        width: 30%;
        font-weight: bold;
        vertical-align: bottom;
      }
      .fin-con-ban-conciliar > .conciliar > table.titulo > tr > td:first-child {
        padding-left: 4px;
        text-align: left;
        width: 30%;
        font-weight: bold;
        vertical-align: bottom;
      }

      .fin-con-ban-conciliar > .conciliar > table.titulo > tr > td > .valor {
        font-size: calc(100% + 2px);
      }
    .fin-con-ban-conciliar > .conciliar > table {
      width: 100%;
      border-collapse: separate;
    }
      .fin-con-ban-conciliar > .conciliar > table > tr > td.separador {
        width: 15px;
        min-width: 15px;
        max-width: 15px;
      }
      .fin-con-ban-conciliar > .conciliar > table > tr > td.fin,
      .fin-con-ban-conciliar > .conciliar > table > tr > td.ofx {
        width: 50%;
        min-width: 50%;
        max-width: 50%;
        background: #fff;
        border-radius: 7px;
        border: 1px solid #ccc;
        padding: 5px 15px;
        vertical-align: top;
      }
        .fin-con-ban-conciliar > .conciliar > table > tr > td.fin > div,
        .fin-con-ban-conciliar > .conciliar > table > tr > td.ofx > div {
          width: 100%;
          min-height: 300px;
        }

        .fin-con-ban-conciliar > .conciliar > table > tr > td.fin > div.disabled,
        .fin-con-ban-conciliar > .conciliar > table > tr > td.ofx > div.disabled {
          cursor: no-drop;
        }

  .fin-con-ban-con--registros {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px 7px;
    clear: both;
  }
    .fin-con-ban-con--registros > caption {
      color: #666;
      padding: 5px;
      background: #f6f6f6;
      border-top: 1px solid #ccc;
      /* border-bottom: 1px solid #ccc; */
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      margin-bottom: -7px;
      height: 40px;
    }
    .fin-con-ban-con--registros > tr:not(:first-child) {
      cursor: pointer;
    }
      .fin-con-ban-con--registros > tr > td {
        text-align: center;
      }
      .fin-con-ban-con--registros > tr:first-child > td {
        font-weight: bold;
        color: #666;
        background: #e6e6e6;
        padding: 5px;
        border-top: 1px solid #d9d9d9;
        border-bottom: 1px solid #d9d9d9;
        border-right: 1px solid #d9d9d9;
      }
      .fin-con-ban-con--registros > tr:first-child > td:first-child {
        border-left: 1px solid #d9d9d9;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      .fin-con-ban-con--registros > tr:first-child > td:last-child {
        border-right: 1px solid #d9d9d9;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      .fin-con-ban-con--registros > tr:not(:first-child) > td {
        padding: 8px;
        background: #f6f6f6;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
      }
      .fin-con-ban-con--registros > tr:not(:first-child) > td:first-child {
        border-left: 1px solid #ccc;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      .fin-con-ban-con--registros > tr:not(:first-child) > td:last-child {
        border-right: 1px solid #ccc;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      .fin-con-ban-con--registros > tr.bg-tab--cinza > td {
        /* color: var(--color-base-01); */
        background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #f8f8f8), color-stop(1, #ececec) );
        background: -moz-linear-gradient( center top, #f8f8f8 5%, #ececec 100% );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f8f8f8', endColorstr='#ececec');
        background-color: #f8f8f8;
      }
      .fin-con-ban-con--registros > tr.bg-tab--amarelo > td {
        background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #f4f1c3), color-stop(1, #ece9bd) );
        background: -moz-linear-gradient( center top, #f4f1c3 5%, #ece9bd 100% );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f4f1c3', endColorstr='#ece9bd');
        background-color: #f4f1c3;
      }
      .fin-con-ban-con--registros > tr.bg-tab--vermelho > td {
        /* color: #fff; */
        background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #f7c6c6), color-stop(1, #ecc5bd) );
        background: -moz-linear-gradient( center top, #f7c6c6 5%, #ecc5bd 100% );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7c6c6', endColorstr='#ecc5bd');
        background-color: #f7c6c6;
      }
      .fin-con-ban-con--registros > tr.bg-tab--verde > td {
        /* color: #fff; */
        background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #cdfacd), color-stop(1, #bdecbd) );
        background: -moz-linear-gradient( center top, #cdfacd 5%, #bdecbd 100% );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#cdfacd', endColorstr='#bdecbd');
        background-color: #cdfacd;
      }
      .fin-con-ban-con--registros > tr.fin-con-ban-con-reg--selecionado > td {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
      }

      .fin-con-ban-con--registros > tr > td.botao-mais {
        background: none !important;
        border: none !important;
        font-weight: bold !important;
      }
</style>

<style>
.fin-con-ban-conciliar > .buscar > div > .fin-con-ban-conciliar--valor {
  margin-right: 10px;
}
.fin-con-ban-conciliar > .buscar > div > .fin-con-ban-conciliar--valor,
.fin-con-ban-conciliar > .buscar > div > .fin-con-ban-conciliar--data {
  margin-bottom: 0px !important;
}
  .fin-con-ban-conciliar > .buscar > div > .fin-con-ban-conciliar--valor > div,
  .fin-con-ban-conciliar > .buscar > div > .fin-con-ban-conciliar--data > div {
    width: 100% !important;
  }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Seletor-Data': () => import('@/components/_geral/Seletor-Data.vue'),
      'App-Financeiro-Registrar-Varios': () => import('@/components/financeiro/Registrar/Financeiro-Registrar-Varios.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        statusFin: 'carregando',
        statusOfx: 'carregando',
        countAll: {
          fin: null,
          ofx: null
        },
        linhas: {
          fin: [],
          ofx: []
        },
        selecionado: {
          fin: {},
          ofx: {}
        },
        adicionar: [],
        campos: {
          conta: {
            id: 'fin-con-ban-conciliar--conta',
            status: '',
            nome: 'Conta',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.finConBanConciliarBuscarContas,
            onChange: this.finConBanConciliarOnChangeValue
          },
          periodo: {
            id: 'fin-con-ban-conciliar--periodo',
            status: '',
            nome: 'Período',
            // optionInicialNome: 'Selecione',
            value: '',
            disabled: false,
            onChange: this.finConBanConciliarOnChangeValue
          },
          tpBusca: {
            id: 'fin-con-ban-conciliar--tpBusca',
            status: '',
            nome: 'Buscar no',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [
              { id: 'fin', nome: 'Rotina Fácil' },
              { id: 'ofx', nome: 'Arquivo OFX' }
            ],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            valueIni: '',
            disabled: false,
            onChange: this.finConBanConciliarOnChangeValue
          },
          conciliado: {
            id: 'fin-con-ban-conciliar--conciliado',
            status: '',
            nome: 'Buscar registros',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [
              { id: 'nao', nome: 'Não conciliados' },
              { id: 'sim', nome: 'Conciliados' },
              { id: '', nome: 'Não conciliados e Conciliados' }
            ],
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: 'nao',
            valueIni: '',
            disabled: false,
            onChange: this.finConBanConciliarOnChangeValue
          },
          valor: {
            id: 'fin-con-ban-conciliar--valor',
            status: '',
            nome: 'Buscar associada por valor',
            value: true,
            explica: { mensagem: 'Marque SIM caso deseje que o sistema busque os registro por proximidade ao registro selecionado' },
            onChange: this.finConBanConciliarOnChangeValue
          },
          data: {
            id: 'fin-con-ban-conciliar--data',
            status: '',
            nome: 'Buscar associada por data',
            value: true,
            explica: { mensagem: 'Marque SIM caso deseje que o sistema busque os registro por proximidade ao registro selecionado' },
            onChange: this.finConBanConciliarOnChangeValue
          }
        }
      }
    },
    mounted: function () {
      if (this.cpntId !== '') {
        // LIMPA AS VARIAVEIS
        this.linhas.fin = []
        this.selecionado.fin = {}
        this.linhas.ofx = []
        this.selecionado.ofx = {}

        // SETA OS VALORES DOS FILTROS
        this.campos.tpBusca.value = 'fin'
        this.campos.conciliado.value = 'sim'

        // REALIZA A BUSCA DO REGISTRO FINANCEIRO
        setTimeout(() => { this.finConBanConciliarBuscarFinanceiro(() => {
          setTimeout(() => { this.finConBanConciliarBuscarConciliar(() => {
            setTimeout(() => {
              // MANDA MARCAR TODAS AS LINHAS ENCONTRADAS PARA FINANCEIRO
              setTimeout(() => { this.finConBanConciliarMarcarTodos('fin') }, 0)

              // MANDA MARCAR TODAS AS LINHAS ENCONTRADAS PARA OFX
              setTimeout(() => { this.finConBanConciliarMarcarTodos('ofx') }, 0)
            }, 0)
          }) }, 0)
        }) }, 0)

        // REALIZA A BUSCA DO REGISTRO OFX
      } else {
        this.finConBanConciliarIniciar()
      }
    },
    methods: {
      finConBanConciliarIniciar: function () {
        if (this.cpntId === '') {
          // LIMPA AS VARIAVEIS
          this.linhas.fin = []
          this.countAll.fin = null
          this.selecionado.fin = {}
          this.linhas.ofx = []
          this.selecionado.ofx = {}
          this.countAll.ofx = null
          
          // QUEBRA LINK DE ASSINCRONO DO JS
          setTimeout(() => {
            // PEGA O TIPO DE BUSCA QUE DEVE FAZER
            var conta = this.finConBanConciliarValorConta()
            var conciliado = this.finConBanConciliarValorConciliado()
            var tpBusca = this.finConBanConciliarValorTipoBusca()

            // VERIFICA SE TEM TODOS OS PARAMETROS PARA BUSCAR
            if ([ '', null, undefined ].indexOf(conta) === -1 && [ '', null, undefined ].indexOf(tpBusca) === -1 && [ '', null, undefined ].indexOf(conciliado) === -1) {
              // FAZ A BUSCA DOS REGISTROS FINANCEIROS
              if ([ 'fin' ].indexOf(tpBusca) !== -1) {
                setTimeout(() => { this.finConBanConciliarBuscarFinanceiro() }, 0)
              }
    
              // FAZ A BUSCA DOS REGISTROS A SEREM CONCILIADOS
              if ([ 'ofx' ].indexOf(tpBusca) !== -1) {
                setTimeout(() => { this.finConBanConciliarBuscarConciliar() }, 0)
              }
            }
          }, 0)
        }
      },
      finConBanConciliarBuscarFinanceiro: function (callback) {
        // PEGA OS VALORES PARA TRABALHAR
        var busca = this.finConBanConciliarValorTipoBusca()
        var conciliado = this.finConBanConciliarValorConciliado()

        // // SETA O STATUS DE CARREGANDO
        // this.statusFin = 'carregando'
        // this.linhas.fin = []

        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: this.linhas.fin.length, qty: 50 } }

        // SETA OS CAMPOS QUE DEVEJA 
        queryGet.field = { id: null, fin_tp: null, valor: null, vcto_pgto: null, id_mod_reg: null, id_modulo: null, status: null }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'status', o: '<>', v: '3' } ] }

        // PEGA OS REGISTRO CONFORME SOLICITADO, CONCILIADO OU NÃO
        if (conciliado === 'nao') {
          queryGet.where.aAnd.push({ f: 'id', o: 'notIn', r: 'id_financeiro', q: {
            model: 'fin_con_bancaria',
            where: { f: 'status', o: '=', v: '1' }
          } })
        } else {
          queryGet.where.aAnd.push({ f: 'id', o: 'in', r: 'id_financeiro', q: {
            model: 'fin_con_bancaria',
            where: { f: 'status', o: '=', v: '1' }
          } })
        }

        // SETA A CONTA QUE DEVE BUSCAR
        queryGet.where.aAnd.push({ f: 'id_conta', o: '=', v: this.finConBanConciliarValorConta() })

        // PEGA OS REGISTRO CONFORME SOLICITADO, CONCILIADO OU NÃO
        if (conciliado === 'sim' && [ '', null, undefined, 'ofx' ].indexOf(busca) !== -1) {
          // INICIA A VARIAVEL DE IDS
          var ids = []

          // CARREGA OS DADOS
          for (var indexO in this.selecionado.ofx) {
            ids.push(this.selecionado.ofx[indexO].id)
          }

          // ADICIONA O VAOR NO VETOR
          queryGet.where.aAnd.push({ f: 'id', o: 'in', r: 'id_financeiro', q: {
            model: 'fin_con_bancaria',
            where: { aAnd: [
              { f: 'status', o: '=', v: '1' },
              { f: 'id_fin_ofx', o: 'in', v: ids.join() }
            ] }
          } })
        } else if ([ '', null, undefined, 'ofx' ].indexOf(busca) !== -1) {
          // INICIA A VARIAVEL DE WHERE
          var where = []

          // VERIFICA O WHERE QUE SERÁ INCLUDO
          for (var indexV in this.selecionado.ofx) {
            // INICIA A VARIAVEL DE WHERE
            var item = []

            // VERIFICA SE TEM QUE BUSCAR POR DATA
            if (this.campos.data.value === true) {
              // PEGA A DATA INICIAL QUE DEVE BUSCAR
              var dataIni = moment(this.selecionado.ofx[indexV]._vcto, 'DD/MM/YYYY').subtract('1', 'day').format('YYYY/MM/DD')
              var dataFim = moment(this.selecionado.ofx[indexV]._vcto, 'DD/MM/YYYY').add('1', 'day').format('YYYY/MM/DD')

              // SETA O FILTRO DE DATA
              item.push({ f: 'vcto_pgto', o: '>=', v: dataIni })
              item.push({ f: 'vcto_pgto', o: '<=', v: dataFim })
            }

            // VERIFICA SE TEM QUE BUSCAR POR VALOR
            if (this.campos.valor.value === true) {
              item.push({ f: 'valor', o: '>=', v: (Number(this.selecionado.ofx[indexV].valor) - 10000).toString() })
              item.push({ f: 'valor', o: '<=', v: (Number(this.selecionado.ofx[indexV].valor) + 10000).toString() })
            }

            // SETA O WHERE QUE DEVE REALIZAR
            if (item.length >= 1) {
              where = where.concat({ aAnd: item })
            }
          }

          // SETA AS INFORMAÇÕES NO WHERE
          if (where.length >= 1) {
            queryGet.where.aAnd = queryGet.where.aAnd.concat({ aAnd: [ { aOr: where } ]})
          }
        } else if ([ '', null, undefined ].indexOf(this.campos.periodo.value) === -1 && typeof this.campos.periodo.value === 'object') {
          queryGet.where.aAnd.push({ aAnd: [
            { f: 'vcto_pgto', o: '>=', v: this.campos.periodo.value._dataIni },
            { f: 'vcto_pgto', o: '<=', v: this.campos.periodo.value._dataFim }
          ] })
        }

        // VERIFICA SE ESTÁ BUSCANDO UM REGISTRO APENAS
        if (this.cpntId !== '') {
          queryGet.where = { aAnd: [ { f: 'status', o: '<>', v: '3' }, { f: 'id', o: '=', v: this.cpntId } ] }
        }

        // SETA A ORDENAÇÃO QUE DEVE APLICAR
        queryGet.order = { vcto_pgto: 'asc', valor: 'asc' }

        // queryGet.return = 'mysqlQuery'
        // delete queryGet.field_virtual

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/financeiro/get', 'POST', queryGet, (retorno) => {
          // SETA O VETOR DE REGISTROS ENCONTRADOS
          var encontrados = []

          // FORMATAR OS VALORES RECEBIDOS
          for (var indexL in retorno.data) {
            // SETA O ID DO REGISTRO ENCONTRADO
            encontrados.push('_' + retorno.data[indexL].id)

            // SETA O TIPO DE REGISTRO
            retorno.data[indexL]._fin_tp =  retorno.data[indexL].fin_tp

            // SETA O VALOR REAL DO CAMPO
            retorno.data[indexL].original = retorno.data[indexL].valor

            // REMOVE O PONTO PARA FORMATAR CORRETAMENTE O CAMPO
            retorno.data[indexL].valor = retorno.data[indexL].valor.replace('.', '')
            retorno.data[indexL].valor = retorno.data[indexL].valor.replace('-', '')

            // FORMATA O VALOR RECEBIDO
            retorno.data[indexL]._valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[indexL].valor)

            // SETA A DATA DE VENCIMENTO DO REGISTRO
            retorno.data[indexL]._vcto = retorno.data[indexL].vcto_pgto_ptbr

            // CALCULA A QUANTIDADE DE DIAS ENTRE AS DATAS
            var diffDias = moment(retorno.data[indexL].vcto_pgto_ptbr, 'DD/MM/YYYY').diff(moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY'), 'days')

            // INICIA A VARIAVEL DA CLASSE
            retorno.data[indexL]._class = ''
            
            // VERIFICA A COR DA LINHA QUE DEVE UTILIZAR
            if (retorno.data[indexL].status === '2' || retorno.data[indexL].status === '4') {
              retorno.data[indexL]._class = 'cinza' // CINZA
            } else if (retorno.data[indexL].status === '1' && diffDias <= 0) {
              retorno.data[indexL]._class = 'vermelho' // VERMELHO
            } else if (retorno.data[indexL].status === '1' && diffDias >= 1 && diffDias <= 7) {
              retorno.data[indexL]._class = 'amarelo' // AMARELO
            } else if (retorno.data[indexL].status === '1' && diffDias >= 8) {
              retorno.data[indexL]._class = 'verde' // VERDE
            }
          }

          // REMOVE AS LINHAS QUE NÃO EXISTE MAIS
          for (var indexD in this.selecionado.fin) {
            if (encontrados.indexOf(indexD) === -1) {
              delete this.selecionado.fin[indexD]
            }
          }

          // SETA OS VALORES RECEBIDOS
          this.linhas.fin = this.linhas.fin.concat(retorno.data)

          // SETA O NUMERO DE REGISTROS ENCONTRADOS
          this.countAll.fin = Number(retorno.countAll)

          // SETA OS VALORES RECEBIDOS
          this.statusFin = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA O CALLBACK RECEBIDO
          if ([ '', null, undefined ].indexOf(callback) === -1 && typeof callback === 'function') {
            callback()
          }
        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.statusFin = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      finConBanConciliarBuscarConciliar: function (callback) {
        // PEGA OS VALORES PARA TRABALHAR
        var busca = this.finConBanConciliarValorTipoBusca()
        var conciliado = this.finConBanConciliarValorConciliado()

        // // SETA O STATUS DE CARREGANDO
        // this.statusOfx = 'carregando'
        // this.linhas.ofx = []

        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: this.linhas.ofx.length, qty: 50 } }

        // SETA OS CAMPOS QUE DEVEJA 
        queryGet.field = { id: null, id_conta: null, type: null, date: null, amount: null, name: null, memo: null }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'status', o: '<>', v: '3' } ] }

        // PEGA OS REGISTRO CONFORME SOLICITADO, CONCILIADO OU NÃO
        if (conciliado === 'nao') {
          queryGet.where.aAnd.push({ f: 'id', o: 'notIn', r: 'id_fin_ofx', q: {
            model: 'fin_con_bancaria',
            where: { f: 'status', o: '=', v: '1' }
          } })
        } else {
          queryGet.where.aAnd.push({ f: 'id', o: 'in', r: 'id_fin_ofx', q: {
            model: 'fin_con_bancaria',
            where: { f: 'status', o: '=', v: '1' }
          } })
        }

        // SETA A CONTA QUE DEVE BUSCAR
        queryGet.where.aAnd.push({ f: 'id_conta', o: '=', v: this.finConBanConciliarValorConta() })

        // VERIFICA A BUSCA QUE DEVE REALIZAR
        if (conciliado === 'sim' && [ '', null, undefined, 'fin' ].indexOf(busca) !== -1) {
          // INICIA A VARIAVEL DE IDS
          var ids = []

          // CARREGA OS DADOS
          for (var indexO in this.selecionado.fin) {
            ids.push(this.selecionado.fin[indexO].id)
          }

          // ADICIONA O VAOR NO VETOR
          queryGet.where.aAnd.push({ f: 'id', o: 'in', r: 'id_fin_ofx', q: {
            model: 'fin_con_bancaria',
            where: { aAnd: [
              { f: 'status', o: '=', v: '1' },
              { f: 'id_financeiro', o: 'in', v: ids.join() }
            ] }
          } })
        } else if ([ '', null, undefined, 'fin' ].indexOf(busca) !== -1) {
          // INICIA A VARIAVEL DE WHERE
          var where = []

          // VERIFICA O WHERE QUE SERÁ INCLUDO
          for (var indexV in this.selecionado.fin) {
            // INICIA A VARIAVEL DE WHERE
            var item = []

            // VERIFICA SE TEM QUE BUSCAR POR DATA
            if (this.campos.data.value === true) {
              // PEGA A DATA INICIAL QUE DEVE BUSCAR
              var dataIni = moment(this.selecionado.fin[indexV]._vcto, 'DD/MM/YYYY').subtract('1', 'day').format('YYYY/MM/DD')
              var dataFim = moment(this.selecionado.fin[indexV]._vcto, 'DD/MM/YYYY').add('1', 'day').format('YYYY/MM/DD')

              // SETA O FILTRO DE DATA
              item.push({ f: 'date', o: '>=', v: dataIni + ' 00:00:00' })
              item.push({ f: 'date', o: '<=', v: dataFim + ' 00:00:00' })
            }

            // VERIFICA SE TEM QUE BUSCAR POR VALOR
            if (this.campos.valor.value === true) {
              item.push({ f: 'amount', o: '>=', v: ((Number(this.selecionado.fin[indexV].valor) - 10000) / 100).toString() })
              item.push({ f: 'amount', o: '<=', v: ((Number(this.selecionado.fin[indexV].valor) + 10000) / 100).toString() })
            }

            // SETA O WHERE QUE DEVE REALIZAR
            if (item.length >= 1) {
              where = where.concat({ aAnd: item })
            }
          }

          // SETA AS INFORMAÇÕES NO WHERE
          if (where.length >= 1) {
            queryGet.where.aAnd = queryGet.where.aAnd.concat({ aOr: where })
          }
        } else if ([ '', null, undefined ].indexOf(this.campos.periodo.value) === -1 && typeof this.campos.periodo.value === 'object') {
          queryGet.where.aAnd.push({ aAnd: [
            { f: 'date', o: '>=', v: this.campos.periodo.value._dataIni + ' 00:00:00' },
            { f: 'date', o: '<=', v: this.campos.periodo.value._dataFim + ' 00:00:00' }
          ] })
        }

        // VERIFICA SE ESTÁ BUSCANDO UM REGISTRO APENAS
        if (this.cpntId !== '') {
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id', o: 'in', r: 'id_fin_ofx', q: {
            model: 'fin_con_bancaria',
            where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_financeiro', o: '=', v: this.cpntId } ] }
          } } ] }
        }

        // SETA A ORDENAÇÃO QUE DEVE APLICAR
        queryGet.order = { date: 'asc', amount: 'asc' }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/financeiro/ofx/get', 'POST', queryGet, (retorno) => {
          // SETA O VETOR DE REGISTROS ENCONTRADOS
          var encontrados = []

          // FORMATAR OS VALORES RECEBIDOS
          for (var indexL in retorno.data) {
            // SETA O ID DO REGISTRO ENCONTRADO
            encontrados.push('_' + retorno.data[indexL].id)

            // SETA O TIPO DE REGISTRO
            retorno.data[indexL]._fin_tp = ''

            // VERIFICA O TIPO DO REGISTRO
            switch (retorno.data[indexL].type) {
              case 'CREDIT':
                retorno.data[indexL]._fin_tp = 'C'
                break

              case 'PAYMENT':
                retorno.data[indexL]._fin_tp = 'D'
                break

              default:
                retorno.data[indexL]._fin_tp = retorno.data[indexL].type
                break
            }

            // SETA O VALOR REAL DO CAMPO
            retorno.data[indexL].original = retorno.data[indexL].amount

            // REMOVE O PONTO PARA FORMATAR CORRETAMENTE O CAMPO
            retorno.data[indexL].valor = retorno.data[indexL].amount.replace('.', '')
            retorno.data[indexL].valor = retorno.data[indexL].valor.replace('-', '')

            // FORMATA O VALOR RECEBIDO
            retorno.data[indexL]._valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[indexL].valor)

            // SETA A DATA DE VENCIMENTO DO REGISTRO
            retorno.data[indexL]._vcto = retorno.data[indexL].date

            // FORMATA O CAMPO
            retorno.data[indexL]._vcto = moment(retorno.data[indexL]._vcto, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
          }

          // REMOVE AS LINHAS QUE NÃO EXISTE MAIS
          for (var indexD in this.selecionado.ofx) {
            if (encontrados.indexOf(indexD) === -1) {
              delete this.selecionado.ofx[indexD]
            }
          }

          // SETA OS VALORES RECEBIDOS
          this.linhas.ofx = this.linhas.ofx.concat(retorno.data)

          // SETA O NUMERO DE REGISTROS ENCONTRADOS
          this.countAll.ofx = Number(retorno.countAll)

          // SETA OS VALORES RECEBIDOS
          this.statusOfx = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA O CALLBACK RECEBIDO
          if ([ '', null, undefined ].indexOf(callback) === -1 && typeof callback === 'function') {
            callback()
          }
        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.statusOfx = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      finConBanConciliarBuscarContas: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEJA 
          queryGet.field = { id: null, tp_conta: null, id_banco: null, agencia: null, agencia_dv: null, conta: null, conta_dv: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [ { f: 'id', o: '<>', v: '1' }, { f: 'status', o: '=', v: '1' } ] }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/financeiro/config/conta/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.finConBanConciliarBuscarContas(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.conta.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.conta.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // TRATA OS VALORES RECEBIDOS
          for (var indexR in registros) {
            // INICIA A VARIAVEL COM O NOME
            registros[indexR].nome = ''

            // MONTA O NOME DO BANCO A SER MOSTRADO
            if ([ '1' ].indexOf(registros[indexR].id) !== -1) {
              registros[indexR].nome = registros[indexR].id_banco
            } else {
              // INICIA A VARIAVEL PARA O CAMINHO DO ICONE DO BANCO
              registros[indexR]._img = '/img/banco/' + registros[indexR].id_banco + '.png'

              // ADICIONA O NUMERO DA AGENCIA
              if ([ '', null, undefined ].indexOf(registros[indexR].agencia) === -1) {
                // SETA O NUMERO DA AGENCIA
                registros[indexR].nome = 'AG.' + registros[indexR].agencia

                // SETA O DIGITO DA AGENCIA
                if ([ '', null, undefined ].indexOf(registros[indexR].agencia_dv) === -1) {
                  registros[indexR].nome += '-' + registros[indexR].agencia_dv
                }
              }
              
              // ADICIONA O NUMERO DA CONTA
              if ([ '', null, undefined ].indexOf(registros[indexR].conta) === -1) {
                // SETA A INICIAL DA CONTA
                registros[indexR].nome += ' C'

                // SETA O TIPO DA CONTA
                switch (registros[indexR].tp_conta) {
                  case '1':
                    registros[indexR].nome += 'C'
                    break

                  case '2':
                    registros[indexR].nome += 'P'
                    break
                }

                // FINALIZA O NOME DA CONTA
                registros[indexR].nome += '.' + registros[indexR].conta

                // SETA O DIGITO DA CONTA
                if ([ '', null, undefined ].indexOf(registros[indexR].conta_dv) === -1) {
                  registros[indexR].nome += '-' + registros[indexR].conta_dv
                }
              }
            }
          }

          // SETA OS VALORES RECEBIDOS
          this.campos.conta.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      finConBanConciliarOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A AÇÃO QUE DEVE REALIZAR PARA CADA CAMPO
        switch (indexF[1]) {
          case 'valor':
          case 'data':
            // PEGA O TIPO DE BUSCA QUE DEVE FAZER
            var busca = this.finConBanConciliarValorTipoBusca()

            // VERIFICA QUAL DEVE ATUALIZAR
            if (Object.keys(this.selecionado[busca].length) >= 1) {
              switch (busca) {
                case 'fin':
                  this.finConBanConciliarBuscarConciliar()
                  break
      
                case 'ofx':
                  this.finConBanConciliarBuscarFinanceiro()
                  break
              }
            }
            break

          case 'conciliado':
          case 'tpBusca':
          case 'conta':
          case 'periodo':
            this.finConBanConciliarIniciar()
            break
        }
      },
      finConBanConciliarLinhaMarcada: function (linha, tipo) {
        // MONTA O VETOR
        var _class = []

        // INICIA A CLASSE DO CAMPO
        _class.push('bg-tab--' + linha._class)

        // INICIA A VARIAVEL CHAVE
        var chave = '_' + linha.id

        // VERIFICA SE A LINHA ESTÁ MARCADA
        if ([ '', null, undefined ].indexOf(this.selecionado[tipo][chave]) === -1) {
          _class = [ 'fin-con-ban-con-reg--selecionado' ]
        }

        // RETORNA A CLASSE A SER USADA
        return _class
      },
      finConBanConciliarMarcarLinha: function (linha, tipo) {
        // INICIA A VARIAVEL CHAVE
        var chave = '_' + linha.id

        // VERIFICA SE DEVE ADICIONAR OU REMOVER
        if ([ '', null, undefined ].indexOf(this.selecionado[tipo][chave]) !== -1) {
          this.selecionado[tipo][chave] = linha
        } else {
          delete this.selecionado[tipo][chave]
        }

        // PEGA O TIPO DE BUSCA QUE DEVE FAZER
        var busca = this.finConBanConciliarValorTipoBusca()

        // VERIFICA SE TEM VALOR NO VETOR
        if (Object.keys(this.selecionado[busca]).length === 0) {
          switch (tipo) {
            case 'fin':
              this.selecionado.ofx = {}
              this.linhas.ofx = []
              this.countAll.ofx = null
              break
  
            case 'ofx':
              this.selecionado.fin = {}
              this.linhas.fin = []
              this.countAll.fin = null
              break
          }
        } else if (tipo === busca) {
          switch (tipo) {
            case 'fin':
              this.finConBanConciliarBuscarConciliar()
              break
  
            case 'ofx':
              this.finConBanConciliarBuscarFinanceiro()
              break
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finConBanConciliarSomaSelecionado: function (tipo) {
        // INICIA A VARIAVEL DE VALOR
        var valor = 0

        // RODA O VETOR SOMANDO OS VALORES
        for (var indexI in this.selecionado[tipo]) {
          valor = this.selecionado[tipo][indexI]._fin_tp === 'C' ? (valor + Number(this.selecionado[tipo][indexI].valor)) : (valor - Number(this.selecionado[tipo][indexI].valor))
        }

        // RETORNA O VALOR MONTADO
        return ('R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString()))
      },
      finConBanExcluirConciliacao: function () {
        if (Object.keys(this.selecionado.ofx).length >= 1 && Object.keys(this.selecionado.fin).length >= 1) {
          // INICIA A VARIAVEL DE IDS
          var ids = { id_financeiro: [], id_fin_ofx: [] }
  
          // CARREGA OS DADOS
          for (var indexO in this.selecionado.ofx) {
            ids.id_fin_ofx.push(this.selecionado.ofx[indexO].id)
          }
          for (var indexF in this.selecionado.fin) {
            ids.id_financeiro.push(this.selecionado.fin[indexF].id)
          }
  
          // INICIA A QUERY QUE SERÁ REALIZADA
          var queryGet = { type: 'list', return: 'arrayGroupByField', field: { id: null }, where: { aAnd: [ { f: 'status', o: '=', v: '1' } ] } }
  
          // ADICIONA O WHERE DE OFX
          queryGet.where.aAnd.push({ f: 'id_fin_ofx', o: 'in', v: ids.id_fin_ofx.join() })
          
          // ADICIONA O WHERE DO FINANCEIRO
          queryGet.where.aAnd.push({ f: 'id_financeiro', o: 'in', v: ids.id_financeiro.join() })
  
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/financeiro/con-bancaria/get', 'POST', queryGet, (retorno) => {
            // PEGA OS VALORES RECEBIDOS
            ids = retorno.data.id.split(',')
  
            // VERIFICA SE PODE EXCLUIR
            if (ids.length <= 0) {
              this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
            } else if (confirm('Deseja realmente excluir a(s) conciliação(ões) selecionada(s)?')) {
              // CRIA O FORMUARIO QUE SERÁ ENVIADO PARA API
              var formData = { j_id: JSON.stringify(ids) }
  
              // CHAMA FUNÇÃO PARA COMUNICAR COM API
              this.$store.state.comunicaAPI('/financeiro/con-bancaria', 'DELETE', formData, (retorno) => {
                // APRESENTA A MENSAGEM RECEBIDA AO USUARIO
                this.$store.state.TRATAR_RET_LOT_API(retorno, null)
  
                // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
                this.time = new Date().getTime()
  
                // CHAMA A FUNÇÃO PARA ATUALIZAR OS TOTAIS DA VENDA
                if (this.cpntId === '') {
                  this.finConBanConciliarIniciar()
                } else {
                  this.cpntFecharFormulario(true)
                }
              }, (apiError) => {
                // SETA OS VALORES RECEBIDOS
                this.statusFin = apiError
      
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              })
            }
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.statusFin = apiError
            this.statusOfx = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro nas duas colunas para prosseguir.', 'warning')
        }
      },
      finConBanConciliarRegistros: function () {
        if (this.finConBanConciliarSomaSelecionado('fin') === this.finConBanConciliarSomaSelecionado('ofx') || confirm('Existe diferença de valores a serem conciliados, deseja continuar?')) {
          // INICIANDO FORMULARIO
          var formData = []
          
          // MONTA O FORMULARIO QUE SERÁ ENVIADO
          for (var indexF in this.selecionado.fin) {
            for (var indexO in this.selecionado.ofx) {
              formData.push({ id_financeiro: this.selecionado.fin[indexF].id, id_fin_ofx: this.selecionado.ofx[indexO].id })
            }
          }
          
          // CONVERTE O FORMULARIO EM LOT
          formData = { lot: formData }
          
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/financeiro/con-bancaria', 'POST', formData, (retorno) => {
            // REINICIANDO O PROCESSO
            setTimeout(() => { this.finConBanConciliarIniciar() }, 0)
  
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno, null, 'WEB [200]: Conciliação realizada com sucesso.')
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.statusFin = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        }
      },
      finConBanConciliarValorConta: function () {
        return (typeof this.campos.conta.value === 'string' ? this.campos.conta.value : this.campos.conta.value.id)
      },
      finConBanConciliarValorTipoBusca: function () {
        return (typeof this.campos.tpBusca.value === 'string' ? this.campos.tpBusca.value : this.campos.tpBusca.value.id)
      },
      finConBanConciliarValorConciliado: function () {
        return (typeof this.campos.conciliado.value === 'string' ? this.campos.conciliado.value : this.campos.conciliado.value.id)
      },
      finConBanConciliarRealizarPesquisa: function () {
        // PEGA OS VALORES SELECIONADOS
        var conta = this.finConBanConciliarValorConta()
        var periodo = this.campos.periodo.value
        var tpBusca = this.finConBanConciliarValorTipoBusca()

        // VERIIFCA OS VALORES
        return [ '', null, undefined ].indexOf(conta) === -1 && [ null, undefined ].indexOf(periodo) === -1 && [ '', null, undefined ].indexOf(tpBusca) === -1
      },
      finConBanConciliarRegistarFinanceiro: function () {
        // INICIA A VARIAVEL
        var ids = []

        // SETA OS VALORES RECEBIDOS
        for (var indexO in this.selecionado.ofx) {
          ids.push(this.selecionado.ofx[indexO].id)
        }
        
        // SETA O VALOR
        this.adicionar = ids

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finConBanConciliarFecharRegistarFinanceiro: function (atualizar, vetor) {
        // SETA O VALOR
        this.adicionar = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE OU NÃO ATUALIZAR ALGUMA COISA
        if (atualizar === true) {
          // INICIANDO FORMULARIO
          var formData = []
          
          // MONTA O FORMULARIO QUE SERÁ ENVIADO
          for (var indexO in vetor) {
            formData.push({ id_financeiro: vetor[indexO], id_fin_ofx: indexO })
          }
          
          // CONVERTE O FORMULARIO EM LOT
          formData = { lot: formData }
          
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/financeiro/con-bancaria', 'POST', formData, (retorno) => {
            // REINICIANDO O PROCESSO
            setTimeout(() => { this.finConBanConciliarIniciar() }, 0)
  
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno, null, 'WEB [200]: Conciliação realizada com sucesso.')
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.statusFin = apiError
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        }
      },
      finConBanConciliarMarcarTodos: function (tipo) {
        // VERIFICA SE DEVE DESMARCAR TODOS OU MARCAR TODOS
        if (this.linhas[tipo].length === Object.keys(this.selecionado[tipo]).length) {
          this.selecionado[tipo] = {}
        } else {
          // LIMPA O VETOR EXISTENTE
          this.selecionado[tipo] = {}
  
          // RODA UM FOR ADICIONANDO O VALOR
          for (var indexL in this.linhas[tipo]) {
            // INICIA A VARIAVEL CHAVE
            var chave = '_' + this.linhas[tipo][indexL].id
  
            // VERIFICA SE DEVE ADICIONAR OU REMOVER
            if ([ '', null, undefined ].indexOf(this.selecionado[tipo][chave]) !== -1) {
              this.selecionado[tipo][chave] = this.linhas[tipo][indexL]
            } else {
              delete this.selecionado[tipo][chave]
            }
          }
        }

        // PEGA O TIPO DE BUSCA QUE DEVE FAZER
        var busca = this.finConBanConciliarValorTipoBusca()

        // VERIFICA SE TEM VALOR NO VETOR
        if (this.cpntId === '') {
          if (Object.keys(this.selecionado[busca]).length === 0) {
            switch (tipo) {
              case 'fin':
                this.selecionado.ofx = {}
                this.linhas.ofx = []
                break
    
              case 'ofx':
                this.selecionado.fin = {}
                this.linhas.fin = []
                break
            }
          } else if (tipo === busca) {
            switch (tipo) {
              case 'fin':
                this.finConBanConciliarBuscarConciliar()
                break
    
              case 'ofx':
                this.finConBanConciliarBuscarFinanceiro()
                break
            }
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finConBanConciliarBotaoMontarTexto: function (valor, chave) {
        // VERIFICA SE TEM VALOR A SER FORMATADO
        if ([ '', null, undefined ].indexOf(valor) !== -1) {
          valor = '0000'
        }

        // FORMATA O VALOR RECEBIDO
        valor = (valor.length <= 4 ? ('0000' + valor).slice(-4) : valor)

        // RETORNA O VALOR MONTADO
        switch (chave) {
          case 'venda':
            valor = 'V ' + valor
            break
        
          case 'compra':
            valor = 'C ' + valor
            break

          case 'comissao':
            valor = 'CMS ' + valor
            break

          case 'despesa':
            valor = 'D ' + valor
            break
        }

        // RETORNA O VALOR
        return valor
      }
    }
  }
</script>
